import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@app/material.module';
import { LoaderComponent } from './loader/loader.component';
import { ErrorPopupComponent } from './error-popup/error-popup.component';
import { MapComponent } from './map/map.component';
import { DeleteConfirmationComponent } from './delete-confirmation/delete-confirmation.component';
import { CounterComponent } from './counter/counter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { WarningDialogComponent } from './dialogs/warning-dialog/warning-dialog.component';
import { DeleteDialogComponent } from './dialogs/delete-dialog/delete-dialog.component';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { CreationSuccessDialogComponent } from './creation-success-dialog/creation-success-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { ImagesViewerComponent } from './dialogs/images-viewer/images-viewer.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { FlightDatePipe } from './pipes/flight-date.pipe';
import { UtcOffsetLabelPipe } from './pipes/utc-offset-label.pipe';
import { ServiceDatePipe } from './pipes/service-date.pipe';
import { ServiceUtcOffsetLabelPipe } from './pipes/service-utc-offset-label.pipe';
import { NumberTranslatePipeModule } from './pipes/number-translate/number-translate.module';
import { AhoyTrackerComponent } from './ahoy-tracker/ahoy-tracker.component';
import { AssetsPipe } from './assets/assets.pipe';
import { AssetsDirective } from './assets/assets.directive';
import { FlightDetailComponent } from './flight-detail/flight-detail.component';
import { ConfirmationDrawerComponent } from './confirmation-drawer/confirmation-drawer.component';
import { CurrencySymbolComponent } from './currency-symbol/currency-symbol.component';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AhoyMapsComponent } from './ahoy-maps/ahoy-maps.service';
import { SectionTitleComponent } from './section-title/section-title.component';
import { InfoPairComponent } from './info-pair/info-pair.component';
import { ProgressTrackerComponent } from './progress-tracker/progress-tracker.component';
import { SlotHoldTimerComponent } from '../@shared/slot-hold-timer/slot-hold-timer.component';
import { AhoyPaginatorComponent } from './ahoy-paginator/ahoy-paginator.component';
import { SectionHeadingComponent } from './section-heading/section-heading.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { StatusBadgeComponent } from './status-badge/status-badge.component';
import { PaymentStatusBadgeComponent } from './payment-status/payment-status-badge.component';
import { TabFilterGroupComponent } from './tab-filter-group/tab-filter-group.component';
import { OutlineBadgeComponent } from './outline-badge/outline-badge.component';
import { AhoyAnalyticsModule } from '@app/ahoy-analytics/ahoy-analytics.module';
import { BarcodeScannerComponent } from './barcode-scanner/barcode-scanner.component';
import { LiveStatusIndicatorComponent } from './live-status-indicator/live-status-indicator.component';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NumberTranslatePipeModule,
    NgbTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    AhoyAnalyticsModule,
  ],
  declarations: [
    LoaderComponent,
    ErrorPopupComponent,
    MapComponent,
    DeleteConfirmationComponent,
    CounterComponent,
    WarningDialogComponent,
    DeleteDialogComponent,
    SuccessDialogComponent,
    CreationSuccessDialogComponent,
    ImagesViewerComponent,
    SafeHtmlPipe,
    FlightDatePipe,
    UtcOffsetLabelPipe,
    ServiceDatePipe,
    ServiceUtcOffsetLabelPipe,
    AhoyTrackerComponent,
    AssetsPipe,
    AssetsDirective,
    FlightDetailComponent,
    ConfirmationDrawerComponent,
    CurrencySymbolComponent,
    ConfirmationDialogComponent,
    AhoyMapsComponent,
    SectionTitleComponent,
    InfoPairComponent,
    ProgressTrackerComponent,
    SlotHoldTimerComponent,
    AhoyPaginatorComponent,
    PhoneInputComponent,
    SectionHeadingComponent,
    BreadcrumbComponent,
    StatusBadgeComponent,
    PaymentStatusBadgeComponent,
    TabFilterGroupComponent,
    OutlineBadgeComponent,
    BarcodeScannerComponent,
    LiveStatusIndicatorComponent,
  ],
  exports: [
    LoaderComponent,
    MapComponent,
    CounterComponent,
    AhoyTrackerComponent,
    AssetsPipe,
    AssetsDirective,
    FlightDetailComponent,
    CurrencySymbolComponent,
    AhoyMapsComponent,
    SectionTitleComponent,
    InfoPairComponent,
    ProgressTrackerComponent,
    SlotHoldTimerComponent,
    AhoyPaginatorComponent,
    PhoneInputComponent,
    SectionHeadingComponent,
    BreadcrumbComponent,
    StatusBadgeComponent,
    PaymentStatusBadgeComponent,
    TabFilterGroupComponent,
    OutlineBadgeComponent,
    AhoyAnalyticsModule,
    BarcodeScannerComponent,
    FlightDatePipe,
    UtcOffsetLabelPipe,
    ServiceDatePipe,
    ServiceUtcOffsetLabelPipe,
    LiveStatusIndicatorComponent,
  ],
})
export class SharedModule {}
